export class Mobile {
    constructor({
        mobileID = 0,
        orderType = null,
        mobileNumber = null,
        ratePlanID = 0,
        simCardNo = null,
        state = null,
        currentCarrier = null,
        accountNo = null,
        addressID = 0,
        dateOfBirth = null
    } = {}) {
        this.mobileID = mobileID;
        this.orderType = orderType;
        this.mobileNumber = mobileNumber;
        this.ratePlanID = ratePlanID;
        this.simCardNo = simCardNo;
        this.state = state;
        this.currentCarrier = currentCarrier;
        this.accountNo = accountNo;
        this.addressID = addressID;
        this.dateOfBirth = dateOfBirth;
    }
}

export function CreateNewMobile(data) {
    return Object.freeze(new Mobile(data))
}
